module.exports = __webpack_public_path__ + "img/external-link.8ff23025.svg";